module.exports = __webpack_public_path__ + "static/media/control_icon.a3edf0c3.png";